import { api } from './api'
import type { SourceType, SourceTypesResponse, SourceTypeResponse } from '../types'

export interface SourceTypesQuery {
  page?: number
  per_page?: number
  is_active?: boolean
}

export class SourceTypesService {
  /**
   * Get all source types with optional filtering
   */
  static async getSourceTypes(
    query: SourceTypesQuery = {}
  ): Promise<SourceTypesResponse> {
    const params = new URLSearchParams()

    if (query.page) params.append('page', query.page.toString())
    if (query.per_page) params.append('per_page', query.per_page.toString())
    if (query.is_active !== undefined) params.append('is_active', query.is_active.toString())

    const response = await api.get<SourceTypesResponse>(
      `/source-types/?${params.toString()}`
    )

    return response.data
  }

  /**
   * Get a single source type by ID
   */
  static async getSourceType(id: number): Promise<SourceType> {
    const response = await api.get<SourceTypeResponse>(`/source-types/${id}`)
    return response.data.data
  }
}
